import VDialog from './dialogWrap.js';
export default VDialog;